exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body.fts-mobile-chart-host{--fts-app-bottom-nav:calc(104px + max(env(safe-area-inset-bottom, 0px) - 20px, 0px))}body.fts-mobile-chart-host .fts-mobile-chart{padding-bottom:calc(.5rem + var(--fts-app-bottom-nav))}body.fts-mobile-chart-host .fts-mobile-chart.fts-mobile-chart--charts{height:auto;min-height:100%}body.fts-mobile-chart-host .d-widget-chart-modal .d-widget-chart-modal__body{padding-bottom:var(--fts-app-bottom-nav)}", ""]);

// exports
